import { render, staticRenderFns } from "./EditHomework.vue?vue&type=template&id=1ed5e4da&scoped=true"
import script from "./EditHomework.vue?vue&type=script&lang=js"
export * from "./EditHomework.vue?vue&type=script&lang=js"
import style0 from "./EditHomework.vue?vue&type=style&index=0&id=1ed5e4da&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed5e4da",
  null
  
)

export default component.exports